import clsx from 'clsx';
import { resolveIcon } from './iconSrc';

interface IconProps {
  /** Path under /public, e.g. `/assets/icons/notepad.svg`. */
  src: string;
  size?: number;
  /** Empty string renders a decorative icon; otherwise it gets an alt. */
  alt?: string;
  className?: string;
}

/**
 * Every icon in the desktop, at whichever size the caller needs.
 *
 * One component and one `size` prop still covers 16px taskbar icons and 48px
 * desktop icons alike; `resolveIcon` decides which of the extracted Windows XP
 * bitmaps that actually means, and falls back to the original SVG for the
 * handful of icons with no XP counterpart.
 */
export function Icon({ src, size = 16, alt = '', className }: IconProps) {
  const resolved = resolveIcon(src, size);

  return (
    <img
      className={clsx('xp-icon', className)}
      src={resolved.src}
      srcSet={resolved.srcSet}
      width={size}
      height={size}
      alt={alt}
      aria-hidden={alt === '' ? true : undefined}
      draggable={false}
    />
  );
}
